/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Broad_Grassy_Husky_RaceInputs */

const fr_broad_grassy_husky_race = /** @type {(inputs: Broad_Grassy_Husky_RaceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Programme`)
};

/**

* @param {Broad_Grassy_Husky_RaceInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const broad_grassy_husky_race = /** @type {((inputs?: Broad_Grassy_Husky_RaceInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Broad_Grassy_Husky_RaceInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_broad_grassy_husky_race(inputs)
});